module.exports = __webpack_public_path__ + "static/media/bg.bc4f19e7.png";